<template>
    <base-dialog-modal
            @exit="onConfirmDetailsCancel"
            @submit="onConfirmDetailsSubmit"
            ref="confirmDetailsDialog"
            submitButton="Confirm"
            v-if="customerIsGuest">
        <template slot="title">Confirm Email</template>
        <template slot="content">
            Please confirm your email is correct as it's where your order will be sent.
            <br>
            <strong>Email: {{customer.email}}</strong>
        </template>
    </base-dialog-modal>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "checkout-customer-email-confirm-modal",
        computed: {
            ...mapGetters('checkout', [
                'customer',
                'askConfirmation',
                'customerIsGuest'
            ])
        },
        watch: {
            askConfirmation(show) {
                if (show) {
                    this.$refs.confirmDetailsDialog.show();

                } else {
                    this.$refs.confirmDetailsDialog.hide();
                }
            },
        },
        methods: {
            onConfirmDetailsCancel() {
                this.$store.dispatch('checkout/guestCustomerDisconfirm');
            },
            onConfirmDetailsSubmit() {
                this.$store.dispatch('checkout/guestCustomerConfirm');
            },
        },
    }
</script>

<style scoped>

</style>